let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dJkIg")).then(() => parcelRequire('cckPC'));